module.exports = __webpack_public_path__ + "components/MapControl/svg/Trasa narciarska.svg?63cece53";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Trasa narciarska.svg
// module id = 2043
// module chunks = 0